import { render, staticRenderFns } from "./cannotAccess.vue?vue&type=template&id=7de6f4cc&"
import script from "./cannotAccess.vue?vue&type=script&lang=js&"
export * from "./cannotAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports